export const PROPOSED_USE = 'proposed-use';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const STATION_DETAILS = 'station-details';
export const NETWORK_INFORMATION = 'network-information';
export const OPERATING_ADDRESS = 'operating-address';
export const FREQUENCY_AND_EMISSION_CLASS_INFORMATION = 'frequency-and-emission-class-information';
export const PORTABLES_INFORMATION = 'portables-information';
export const FREQUENCY_ENTRY = 'frequency-entry';
export const LAND_FIXED_STATION = 'land-fixed-station';
export const LAND_FIXED_STATION_DETAILS = 'land-fixed-station-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_LPN_APPLICATION = [
    {
        sectionID: PROPOSED_USE,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'proposed-use',
                label: 'Proposed use of System',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information',
        fieldList: [
            {
                id: 'company-name',
                label: 'Company Name',
                type: 'text'
            },
            {
                id: 'vendors-dealers-licence-number',
                label: 'Vendor’s Dealer’s Licence Number',
                type: 'text'
            },
            {
                id: 'contact-person',
                label: 'Contact Person',
                type: 'text'
            },
            {
                id: 'contact-number-optional',
                label: 'Contact Number (Optional)',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Vendor Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LAND_FIXED_STATION,
        sectionName: '',
        fieldList: [
            {
                id: 'any-land-fixed-station',
                label: 'Any Land Fixed Station?',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'station-tabs-2',
                label: '',
                type: 'tab',
                span: 12,
                tabs: [
                    {
                        id: '1',
                        label: 'Network Details',
                        tabContent: [
                            {
                                id: 'network-information',
                                label: 'Network Information',
                                type: 'subsection'
                            },
                            {
                                id: 'do-you-have-the-postal-code',
                                label: 'Do you have the postal code?',
                                type: 'text'
                            },
                            {
                                id: 'operating-address',
                                label: 'Operating Address',
                                type: 'subsection'
                            },
                            {
                                id: 'building-name',
                                label: 'Building Name',
                                type: 'text'
                            },
                            {
                                id: 'postal-code',
                                label: 'Postal Code',
                                type: 'text'
                            },
                            {
                                id: 'street-name',
                                label: 'Street Name',
                                type: 'text'
                            },
                            {
                                id: 'block-house-no',
                                label: 'Block/House No.',
                                type: 'text'
                            },
                            {
                                id: 'floor-level-optional',
                                label: 'Floor/Level (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'unit-optional',
                                label: 'Unit (Optional)',
                                type: 'text'
                            },
                            {
                                id: 'do-you-have-the-mukim-or-land-lot-number',
                                label: 'Do you have the Mukim or Land Lot Number?',
                                type: 'text'
                            },
                            {
                                id: 'mukim-land-lot-number',
                                label: 'Mukim/Land Lot Number',
                                type: 'text'
                            },
                            {
                                id: 'latitude',
                                label: 'Latitude',
                                type: 'subsection'
                            },
                            {
                                id: 'latitude-degrees',
                                label: 'Latitude Degrees',
                                type: 'text'
                            },
                            {
                                id: 'latitude-minutes',
                                label: 'Latitude Minutes',
                                type: 'text'
                            },
                            {
                                id: 'latitude-seconds',
                                label: 'Latitude Seconds',
                                type: 'text'
                            },
                            {
                                id: 'longitude',
                                label: 'Longitude',
                                type: 'subsection'
                            },
                            {
                                id: 'longitude-degrees',
                                label: 'Longitude Degrees',
                                type: 'text'
                            },
                            {
                                id: 'longitude-minutes',
                                label: 'Longitude Minutes',
                                type: 'text'
                            },
                            {
                                id: 'longitude-seconds',
                                label: 'Longitude Seconds',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-and-emission-class-information',
                                label: 'Desired Frequency and Emission Class Information',
                                type: 'subsection'
                            },
                            {
                                id: 'number-of-frequencies-required',
                                label: 'Number of Frequency(ies) required',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-information',
                                label: '',
                                type: 'subsection',
                                fieldlist: [
                                    {
                                        id: 'desired-frequency-information-table',
                                        label: '',
                                        type: 'table',
                                        subFields: [
                                            {
                                                id: 'id-no',
                                                header: 'S/N',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-from-tx',
                                                header: 'Desired Frequency (MHz) - From (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-to-tx',
                                                header: 'Desired Frequency (MHz) - To (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-from-rx',
                                                header: 'Desired Frequency (MHz) - From (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-to-rx',
                                                header: 'Desired Frequency (MHz) - To (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-bandwidth-khz-tx',
                                                header: 'Desired Bandwidth (kHz) (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-bandwidth-khz-rx',
                                                header: 'Desired Bandwidth (kHz) (Rx)',
                                                type: 'text'
                                            }
                                        ]
                                    },
                                    {
                                        id: 'desired-frequency-information-accordion',
                                        label: '',
                                        type: 'accordion',
                                        subFields: [
                                            {
                                                id: 'emission-class-transmit',
                                                label: 'Emission Class - Transmit',
                                                type: 'text'
                                            },
                                            {
                                                id: 'output-power-required-werp',
                                                label: 'Output Power Required (Werp)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'transmission-power',
                                                label: 'Transmission Power (W)',
                                                type: 'text'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: '2',
                        label: 'Land Fixed Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'station-name',
                                        label: 'Station Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'location-of-station',
                                        label: 'Location of Station',
                                        type: 'text'
                                    },
                                    {
                                        id: 'station-type',
                                        label: 'Station Type',
                                        type: 'text'
                                    },
                                    {
                                        id: 'operating-address',
                                        label: 'Operating Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name-optional',
                                        label: 'Building Name (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit-optional',
                                        label: 'Unit (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level-optional',
                                        label: 'Floor/Level (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'building-height-m',
                                        label: 'Building Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-structure-height-m',
                                        label: 'Antenna Structure Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'elevation-angle-above-mean-sea-level-m',
                                        label: 'Elevation Angle Above Mean Sea Level (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'coverage-radius-link-distance-km',
                                        label: 'Coverage Radius/Link Distance (km)',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transportable',
                                        label: 'Transportable?',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-transmit-type',
                                        label: 'Feeder Line - Transmit (Type)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-receive-type',
                                        label: 'Feeder Line - Receive (Type)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transmit-length-in-m',
                                        label: 'Transmit (Length in m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'receive-length-in-m',
                                        label: 'Received (Length in m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transmit-loss-in-db',
                                        label: 'Transmit (Loss in dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'received-loss-in-db',
                                        label: 'Received (Loss in dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'system-emission-power-w',
                                        label: 'System Emission Power (W)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'system-emission-power-type-werp-or-weirp',
                                        label: 'System Emission Power Type (WERP or WEIRP)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transmitter-manufacturer',
                                        label: 'Transmitter Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transmitter-model',
                                        label: 'Transmitter Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transmitter-power-w',
                                        label: 'Transmitter Power (W)',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'receiver-manufacturer',
                                        label: 'Receiver Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'receiver-model',
                                        label: 'Receiver Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-manufacturer',
                                        label: 'Antenna Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-model',
                                        label: 'Antenna Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-effective-height-m-above-ground-level',
                                        label: 'Antenna Effective Height (m) (above ground level)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'gain-db',
                                        label: 'Gain (dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'elevation-angle',
                                        label: 'Elevation Angle',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'filter-manufacturer',
                                        label: 'Filter Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'filter-model',
                                        label: 'Filter Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'insertion-loss-db',
                                        label: 'Insertion Loss (dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'tuned-frequency-mhz',
                                        label: 'Tuned Frequency (MHz)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'polarization',
                                        label: 'Polarization',
                                        type: 'text'
                                    },
                                    {
                                        id: 'frequency-and-emission-class-information',
                                        label: 'Station - Frequency Info',
                                        type: 'subsection',
                                        fieldlist: [
                                            {
                                                id: 'frequency-and-emission-class-information-table',
                                                label: '',
                                                type: 'table',
                                                subFields: [
                                                    {
                                                        id: 'desired-frequency-mhz-from-tx',
                                                        header: 'Desired Frequency (MHz) - From (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-tx',
                                                        header: 'Desired Frequency (MHz) - To (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-from-rx',
                                                        header: 'Desired Frequency (MHz) - From (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-rx',
                                                        header: 'Desired Frequency (MHz) - To (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-bandwidth-khz-tx',
                                                        header: 'Desired Bandwidth (kHz) (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-bandwidth-khz-rx',
                                                        header: 'Desired Bandwidth (kHz) (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'start-time',
                                                        header: 'Start Time',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'stop-time',
                                                        header: 'Stop Time',
                                                        type: 'text'
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'frequency-and-emission-class-information-accordion',
                                                label: '',
                                                type: 'accordion',
                                                subFields: [
                                                    {
                                                        id: 'emission-class-transmit',
                                                        label: 'Emission Class - Transmit',
                                                        type: 'text'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: '3',
                        label: 'Mobile/Portable Details',
                        tabContent: [
                            {
                                id: 'desired-frequency-and-emission-class-information',
                                label: 'Desired Frequency and Emission Class Information',
                                type: 'subsection'
                            },
                            {
                                id: 'number-of-frequencies-required',
                                label: 'Number of Frequency(ies) required',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-information',
                                label: '',
                                type: 'subsection',
                                fieldlist: [
                                    {
                                        id: 'desired-frequency-information-table',
                                        label: '',
                                        type: 'table',
                                        subFields: [
                                            {
                                                id: 'id-no',
                                                header: 'S/N',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-from-tx',
                                                header: 'Desired Frequency (MHz) - From (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-to-tx',
                                                header: 'Desired Frequency (MHz) - To (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-from-rx',
                                                header: 'Desired Frequency (MHz) - From (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-frequency-mhz-to-rx',
                                                header: 'Desired Frequency (MHz) - To (Rx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-bandwidth-khz-tx',
                                                header: 'Desired Bandwidth (kHz) (Tx)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'desired-bandwidth-khz-rx',
                                                header: 'Desired Bandwidth (kHz) (Rx)',
                                                type: 'text'
                                            }
                                        ]
                                    },
                                    {
                                        id: 'desired-frequency-information-accordion',
                                        label: '',
                                        type: 'accordion',
                                        subFields: [
                                            {
                                                id: 'emission-class-transmit',
                                                label: 'Emission Class - Transmit',
                                                type: 'text'
                                            },
                                            {
                                                id: 'output-power-required-werp',
                                                label: 'Output Power Required (Werp)',
                                                type: 'text'
                                            },
                                            {
                                                id: 'transmission-power',
                                                label: 'Transmission Power (W)',
                                                type: 'text'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 'portables-information',
                                label: 'Portables Information',
                                type: 'subsection',
                                fieldlist: [
                                    {
                                        id: 'portables-information-table',
                                        label: '',
                                        type: 'table',
                                        subFields: [
                                            {
                                                id: 'no',
                                                header: 'No.',
                                                type: 'text'
                                            },
                                            {
                                                id: 'manufacturer',
                                                header: 'Manufacturer',
                                                type: 'text'
                                            },
                                            {
                                                id: 'model',
                                                header: 'Model',
                                                type: 'text'
                                            },
                                            {
                                                id: 'number-of-portable-stations',
                                                header: 'Number of Portable Station(s)',
                                                type: 'text'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
